Vue.config.productionTip = false

Vue.use(Vuetify, {})
// Vue.use(VueFirestore)
// Vue.use(VueFire)
Vue.use(VueRouter)

import App from './App.vue'

const configured_vue_router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'app',
      component: App,
    },
  ]
})

window.S = require('./state.js').default

new Vue({
  router: configured_vue_router,
  render: h => h(App)
}).$mount('#app')
